import { Link } from 'react-router-dom';

interface ExpenseTrackerBannerProps {
  compact?: boolean;
}

export default function ExpenseTrackerBanner({ compact = false }: ExpenseTrackerBannerProps) {
  if (compact) {
    return (
      <div className="bg-gradient-to-r from-emerald-600 to-teal-600 rounded-xl p-4 shadow-lg">
        <div className="flex items-center justify-between gap-4 flex-wrap">
          <div className="flex items-center gap-3">
            <div className="flex-shrink-0 w-10 h-10 bg-white/20 rounded-lg flex items-center justify-center text-2xl">
              💰
            </div>
            <div>
              <div className="text-white font-bold text-sm">Track Expenses Like a Pro</div>
              <div className="text-emerald-100 text-xs">Audit-proof expense tracking · $5.99/mo</div>
            </div>
          </div>
          <Link
            to="/tools/expense-tracker"
            className="px-5 py-2.5 bg-white text-emerald-700 rounded-lg font-semibold text-sm hover:bg-emerald-50 transition-all whitespace-nowrap shadow-md"
          >
            Try Free →
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-gradient-to-br from-emerald-600 via-green-600 to-teal-600 rounded-2xl p-6 shadow-xl border-2 border-emerald-400/20">
      <div className="flex items-start justify-between gap-6 flex-wrap">
        <div className="flex-1 min-w-[250px]">
          <div className="inline-flex items-center gap-2 px-2.5 py-1 rounded-full bg-yellow-400 text-yellow-900 font-bold text-xs mb-3">
            <span>⭐</span>
            <span>PREMIUM TOOL</span>
          </div>
          
          <h3 className="text-xl font-bold text-white mb-2">
            Professional Expense Tracker
          </h3>
          
          <p className="text-emerald-50 text-sm mb-4 leading-relaxed">
            Track expenses with real-time audit risk scoring. Know which deductions are safe with AI-powered categorization.
          </p>
          
          <div className="grid grid-cols-2 gap-2 mb-4 text-sm">
            <div className="flex items-center gap-1.5">
              <span className="text-emerald-300">✓</span>
              <span className="text-white">Unlimited tracking</span>
            </div>
            <div className="flex items-center gap-1.5">
              <span className="text-emerald-300">✓</span>
              <span className="text-white">Receipt uploads</span>
            </div>
            <div className="flex items-center gap-1.5">
              <span className="text-emerald-300">✓</span>
              <span className="text-white">Bank imports</span>
            </div>
            <div className="flex items-center gap-1.5">
              <span className="text-emerald-300">✓</span>
              <span className="text-white">Tax estimates</span>
            </div>
          </div>
          
          <div className="flex gap-2">
            <Link
              to="/tools/expense-tracker"
              className="px-5 py-2.5 bg-white text-emerald-700 rounded-lg font-bold text-sm hover:bg-emerald-50 transition-all shadow-lg"
            >
              Start Free Trial
            </Link>
            <div className="px-3 py-2.5 text-white text-sm font-semibold">
              Only $5.99/mo
            </div>
          </div>
        </div>
        
        <div className="flex-shrink-0 bg-white/10 backdrop-blur-sm rounded-xl p-4 border border-white/20">
          <div className="text-center">
            <div className="text-3xl mb-2">📊</div>
            <div className="text-white font-bold text-sm mb-1">1,000+</div>
            <div className="text-emerald-100 text-xs">Active Users</div>
            <div className="flex items-center justify-center gap-0.5 mt-2">
              {[...Array(5)].map((_, i) => (
                <svg key={i} className="w-3 h-3 text-yellow-300 fill-current" viewBox="0 0 20 20">
                  <path d="M10 15l-5.878 3.09 1.123-6.545L.489 6.91l6.572-.955L10 0l2.939 5.955 6.572.955-4.756 4.635 1.123 6.545z" />
                </svg>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
